import Link from 'next/link';
import { memo } from 'react';

import { FileStatusIconCompleted, FileStatusSubtitle, FileStatusTitle } from '@air/feature-file-status/ui';

import { getTaskPaneFileStatusIconSize } from '~/components/FileStatusTrackingPane/getTaskPaneFileStatusIconSize';
import { PaneItemTW } from '~/components/FileStatusTrackingPane/PaneItemTW';
import { TaskPaneDismissButton } from '~/components/FileStatusTrackingPane/TaskPaneDismissButton';
import { Routes } from '~/constants/routes';
import { useTemporaryFeatureFlags } from '~/hooks/useTemporaryFeatureFlags';
import { type GetCompletedMetadata, type LibraryDeletionTask } from '~/store/tasks/types';

export type DuplicateBoardCompletedPanelItemProps = {
  metadata: GetCompletedMetadata<LibraryDeletionTask>;
  onClear: () => void;
};

export const DeleteLibraryCompletedPanelItem = memo(({ onClear }: DuplicateBoardCompletedPanelItemProps) => {
  const { ui2026 } = useTemporaryFeatureFlags();

  return (
    <PaneItemTW
      truncate={false}
      avatar={<FileStatusIconCompleted size={getTaskPaneFileStatusIconSize(ui2026)} />}
      title={<FileStatusTitle>{ui2026 ? 'Library deleted' : 'Deleted successfully'}</FileStatusTitle>}
      subtitle={
        <FileStatusSubtitle className="truncate">
          Library moved to{' '}
          <Link
            href={Routes.media.recentlyDeleted}
            className="cursor-pointer font-semibold ads:text-accent text-altitude-9 ads:hover:text-accent-hover hover:text-altitude-11 hover:underline"
          >
            {ui2026 ? 'Recently Deleted' : 'Recently deleted'}
          </Link>
        </FileStatusSubtitle>
      }
      buttons={<TaskPaneDismissButton label="Clear" onClick={onClear} />}
    />
  );
});

DeleteLibraryCompletedPanelItem.displayName = 'DeleteLibraryCompletedPanelItem';
